import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Popover, Box, Backdrop } from '@mui/material';
import { Icon } from '@iconify/react';
import EmojiPicker from 'emoji-picker-react';

const EmojiPickerButton = ({ onEmojiSelect, disabled, buttonSx, isMobile }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const open = isMobile ? mobileOpen : Boolean(anchorEl);

    const handleClick = (event) => {
        if (isMobile) {
            setMobileOpen(true);
        } else {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        if (isMobile) {
            setMobileOpen(false);
        } else {
            setAnchorEl(null);
        }
    };

    const handleEmojiClick = (emojiData) => {
        onEmojiSelect(emojiData.emoji);
        handleClose();
    };

    return (
        <>
            <IconButton
                onClick={handleClick}
                disabled={disabled}
                sx={{
                    width: isMobile ? '44px' : '36px',
                    height: isMobile ? '44px' : '36px',
                    minWidth: isMobile ? '44px' : undefined,
                    minHeight: isMobile ? '44px' : undefined,
                    borderRadius: '50%',
                    color: open ? '#00AB55' : '#637381',
                    '&:hover': {
                        backgroundColor: 'rgba(145, 158, 171, 0.16)',
                    },
                    ...buttonSx,
                }}
            >
                <Icon icon="mdi:emoticon-happy-outline" width={20} height={20} />
            </IconButton>

            {/* Desktop: Popover */}
            {!isMobile && (
                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    slotProps={{
                        paper: {
                            sx: {
                                borderRadius: '12px',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                                overflow: 'hidden',
                            },
                        },
                    }}
                >
                    <EmojiPicker
                        onEmojiClick={handleEmojiClick}
                        width={350}
                        height={400}
                        searchPlaceholder="Search emoji..."
                        previewConfig={{ showPreview: false }}
                        skinTonesDisabled={false}
                        lazyLoadEmojis
                    />
                </Popover>
            )}

            {/* Mobile: Bottom Sheet */}
            {isMobile && mobileOpen && (
                <>
                    <Backdrop
                        open
                        onClick={handleClose}
                        sx={{ zIndex: 1299, backgroundColor: 'rgba(0,0,0,0.5)' }}
                    />
                    <Box
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            zIndex: 1300,
                            borderRadius: '16px 16px 0 0',
                            overflow: 'hidden',
                            boxShadow: '0 -8px 24px rgba(0,0,0,0.15)',
                            backgroundColor: '#fff',
                        }}
                    >
                        <EmojiPicker
                            onEmojiClick={handleEmojiClick}
                            width="100%"
                            height="50vh"
                            searchPlaceholder="Search emoji..."
                            previewConfig={{ showPreview: false }}
                            skinTonesDisabled={false}
                            lazyLoadEmojis
                        />
                    </Box>
                </>
            )}
        </>
    );
};

EmojiPickerButton.propTypes = {
    onEmojiSelect: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    buttonSx: PropTypes.object,
    isMobile: PropTypes.bool,
};

EmojiPickerButton.defaultProps = {
    disabled: false,
    buttonSx: {},
    isMobile: false,
};

export default EmojiPickerButton;
